import { TinkLinkUrlParameter } from '@tink/config/src/TinkLinkUrlParameter';
import { getParameter } from '../../../../../utilities/urlParametersValidator';

export class ParentLoadingMessenger {
  private currentLoadingStatus: boolean | undefined = undefined;

  private propagateStopLoadingTimerId: number | undefined = undefined;

  public reset() {
    this.currentLoadingStatus = undefined;
  }

  // eslint-disable-next-line class-methods-use-this
  private notifyParent(loadingStatus: boolean) {
    const message = ParentLoadingMessenger.buildParentMessage(loadingStatus);
    const targetOrigin = getParameter(TinkLinkUrlParameter.REDIRECT_URI) || '*';

    try {
      window.parent.postMessage(message, targetOrigin);
    } catch (error) {
      // Parent does not match `redirectUri`.
    }
  }

  static buildParentMessage(loadingStatus: boolean) {
    return JSON.stringify({
      type: 'status',
      data: {
        loading: loadingStatus,
      },
    });
  }

  public execute(
    newLoadingStatus: boolean,
    notifyParentHandler: (status: boolean) => void = this.notifyParent.bind(this) // We mock this function in tests.
  ) {
    // Initial loading status change, propagate update immediately.
    if (this.currentLoadingStatus === undefined) {
      this.currentLoadingStatus = newLoadingStatus;
      notifyParentHandler(this.currentLoadingStatus);

      return;
    }

    if (newLoadingStatus) {
      clearTimeout(this.propagateStopLoadingTimerId);
    }

    if (this.currentLoadingStatus === newLoadingStatus) {
      return;
    }

    if (newLoadingStatus) {
      this.currentLoadingStatus = newLoadingStatus;
      notifyParentHandler(this.currentLoadingStatus);
    } else {
      // We deffer posting 'stop loading' message to parent, in case there's another 'start loading' action incomming.
      // We do this to prevent sending 'start/stop/start/stop' messages to parent, instead we send only 'start/stop'.
      this.propagateStopLoadingTimerId = window.setTimeout(() => {
        this.currentLoadingStatus = newLoadingStatus;
        notifyParentHandler(this.currentLoadingStatus);
      }, 30);
    }
  }
}

export const parentLoadingMessenger = new ParentLoadingMessenger();
